import { render, staticRenderFns } from "./initiative-details.view.vue?vue&type=template&id=5b39aeae&scoped=true&"
import script from "./initiative-details.view.vue?vue&type=script&lang=ts&"
export * from "./initiative-details.view.vue?vue&type=script&lang=ts&"
import style0 from "./initiative-details.view.vue?vue&type=style&index=0&id=5b39aeae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39aeae",
  null
  
)

export default component.exports